import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_dormitory,
  add_dormitory,
  update_dormitory,
  delete_dormitory,
  get_dormitory_list,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  dormitory: [],
  dormitorylist: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    description: "",
    hostel_room: "",
    hostel_category: "",
    capacity: 0,
    address: "",
  },
};

// Async Thunks for API Calls
export const fetchdormitorylist = createAsyncThunk(
  "dormitory/fetchdormitorylist",
  async ({ school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_dormitory_list(school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async Thunks for API Calls
export const fetchdormitory = createAsyncThunk(
  "dormitory/fetchdormitory",
  async (
    { page, page_size, school_id, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_dormitory(
        page,
        page_size,
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createdormitory = createAsyncThunk(
  "dormitory/createdormitory",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_dormitory(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatedormitory = createAsyncThunk(
  "dormitory/updatedormitory",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_dormitory(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletedormitory = createAsyncThunk(
  "dormitory/deletedormitory",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_dormitory({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// dormitory Slice
const dormitorySlice = createSlice({
  name: "dormitorys",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
      
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
        name,
        description,
        hostel_room,
        hostel_category,
        capacity,
        address,
      } = action.payload;
      state.formData = {
        id,
        name,
        description,
        hostel_room,
        hostel_category,
        capacity,
        address,
      };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        description: "",
        hostel_room: "",
        hostel_category: "",
        capacity: state.formData.capacity,
        address: "",
      };
    },
    setDormitory(state, action) {
      state.dormitory = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchdormitorylist.fulfilled, (state, action) => {
        state.dormitorylist = action.payload.data;
      })
      // Fetch dormitory
      .addCase(fetchdormitory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchdormitory.fulfilled, (state, action) => {
        state.loading = false;
        state.dormitory = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchdormitory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add dormitory
      .addCase(createdormitory.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createdormitory.fulfilled, (state, action) => {
        state.addLoading = false;
        state.dormitory = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createdormitory.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update dormitory
      .addCase(updatedormitory.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatedormitory.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatedormitory.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete dormitory
      .addCase(deletedormitory.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletedormitory.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletedormitory.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setDormitory,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
} = dormitorySlice.actions;
export default dormitorySlice.reducer;
